@if (useChips == false) {
  <nts-base-numeric-box #baseNumericBox
    [value]="propertyViewModel.value$ | async"
    [isDisabled]="!(filter.isEnabled$ | async) || !(propertyViewModel.isEnabled$ | async)"
    (onFocus)="selectAllContent($event)"
    [maskSettings]="this.inputMaskSettings" [minValue]="this.minValue"
  [maxValue]="this.maxValue"></nts-base-numeric-box>
}
@if (useChips == true) {
  <nts-base-chips-box
    #baseChipsBox
    [isDisabled]="!(filter.isEnabled$ | async) || !(propertyViewModel.isEnabled$ | async)"
    (onValueChange)="valueChange($event)"
    [value]="valueForChips"
    >
  </nts-base-chips-box>
}